import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import tourManagerReducer from '../reducers/tourManagerReducer';

const configureStore = (railsProps) => (
  createStore(tourManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
